<template>
  <div :class='[{ mobile: this.isMobile }]'><router-view /> </div>
</template>
<script>
import { browser, os } from '@/utils/common'
export default {
  components: {

  },
  data () {
    return {
    }
  },
  computed: {
    isMobile () {
      return browser.isMobile
    }
  },
  watch: {

  },
  mounted () {

  },
  beforeDestroy () {

  },
  created () {

  },
  methods: {

  }
}
</script>
<style>
html {
  /* background-color: #f6f6f6; */
}

html,
body,
div {
  box-sizing: border-box;
}

body,
html {
  padding: 0;
  margin: 0;
  overflow: auto;
  /* 允许内容滚动 */
  scrollbar-width: none;

  /* 隐藏滚动条 */
  -ms-overflow-style: none;
  /* 隐藏滚动条 */
}

/* 隐藏滚动条样式 */
body::-webkit-scrollbar,
html::-webkit-scrollbar {
  width: 0;
  /* 设置滚动条宽度为0 */
  height: 0;
  /* 设置滚动条高度为0 */
}

body::-webkit-scrollbar-track {
  background-color: transparent;
  /* 设置滚动条轨道颜色为透明 */
}

body::-webkit-scrollbar-thumb {
  background-color: transparent;
  /* 设置滚动条滑块颜色为透明 */
}

body::-webkit-scrollbar-thumb:hover {
  background-color: transparent;
}
</style>
